module.exports = __webpack_public_path__ + "static/img/7-2.56e9d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/7-2.png
// module id = 1cDB
// module chunks = 1